import { useState } from 'react';

export default function FAQSection() {
  const faqs = [
    {
      q: 'Что входит в тренинг по телефонным продажам?',
      a: 'Тренинг включает диагностику текущего уровня команды, прослушивание реальных звонков, практическую отработку навыков на кейсах компании, работу с возражениями, обучение технике SPIN и активному слушанию, домашние задания и посттренинговое сопровождение с разбором новых записей разговоров.',
    },
    {
      q: 'Чем обучение отличается от обычного тренинга по холодным звонкам?',
      a: 'Это не тренинг по скриптам, а системное обучение управлению телефонной продажей. Мы не учим зачитывать готовые фразы — мы развиваем навыки: как открыть разговор, удержать внимание, выявить настоящую потребность, работать с эмоциями клиента и завершить звонок конкретным следующим шагом. Плюс программа включает сопровождение внедрения, а не только однодневное мероприятие.',
    },
    {
      q: 'Можно ли обучить опытных менеджеров?',
      a: 'Да, опытные менеджеры часто получают наибольшую отдачу от обучения. Мы выявляем скрытые неэффективные привычки, накопившиеся за годы, усиливаем сильные стороны и помогаем выйти на качественно новый уровень конверсии. Программа адаптируется под уровень каждого участника — от новичков до руководителей.',
    },
    {
      q: 'Работаете ли вы с B2B?',
      a: 'Да, мы специализируемся на B2B-продажах. Обучаем выходить на ЛПР, проходить секретарей и ассистентов, формулировать ценность для бизнес-аудитории, проводить многоэтапные переговоры и назначать встречи с лицами, принимающими решения. Все кейсы строятся на реальных сценариях из вашей отрасли.',
    },
    {
      q: 'Можно ли анализировать реальные звонки?',
      a: 'Да, это основа нашей программы. Мы прослушиваем реальные записи звонков ваших менеджеров до обучения, анализируем их вместе с участниками и разбираем: что работает, что теряет клиента, как усилить каждый этап разговора. Это в десятки раз эффективнее абстрактных упражнений.',
    },
    {
      q: 'Проводится ли обучение онлайн?',
      a: 'Да, тренинг полностью доступен в онлайн-формате: живые сессии с отработкой звонков через видеосвязь, ролевые переговоры, детальный разбор реальных записей разговоров. Онлайн-формат полностью сохраняет практическую направленность и эффективность обучения.',
    },
    {
      q: 'Сколько длится программа?',
      a: 'Форматы варьируются: интенсивный тренинг — 1-2 полных дня, модульная программа — от 2 недель до 2 месяцев, комплексная программа с сопровождением — 3-6 месяцев. Точная продолжительность определяется после диагностики текущего уровня команды и поставленных бизнес-целей.',
    },
    {
      q: 'Что происходит после тренинга?',
      a: 'После основного тренинга мы продолжаем работу: разбираем новые записи звонков, корректируем стратегию, поддерживаем участников в чате, помогаем внедрять регламенты и стандарты. Именно посттренинговое сопровождение обеспечивает закрепление навыков и устойчивый рост показателей.',
    },
    {
      q: 'Как быстро появляются результаты?',
      a: 'Первые изменения в качестве разговора видны уже после первого дня обучения. Измеримые бизнес-результаты — рост конверсии, увеличение назначенных встреч, сокращение цикла сделки — обычно проявляются через 2-4 недели при условии активного внедрения и сопровождения.',
    },
    {
      q: 'Можно ли провести обучение в Минске и других странах?',
      a: 'Да, мы проводим обучение в Минске, а также выезжаем в любую точку Беларуси, России, Казахстана и других стран СНГ. Онлайн-формат доступен для компаний из любой точки мира. География наших проектов включает десятки городов.',
    },
    {
      q: 'Чем ваш подход к обучению телефонным продажам отличается от конкурентов?',
      a: 'Ключевое отличие — мы не просто проводим тренинг, а сопровождаем внедрение. Практика на реальных звонках компании, а не на абстрактных кейсах. Диагностика до обучения позволяет настроить программу под конкретные проблемы отдела. Посттренинговое сопровождение с разбором новых записей и Telegram-поддержкой обеспечивает закрепление навыков и устойчивый рост конверсии.',
    },
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Часто задаваемые вопросы
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-100 overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full text-left px-5 md:px-6 py-4 flex items-center justify-between gap-4 cursor-pointer group hover:bg-gray-50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-gray-900">{faq.q}</span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIndex === i ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-500 group-hover:bg-teal-100 group-hover:text-teal-600'}`}>
                  <i className={`text-sm transition-transform ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-out overflow-hidden ${openIndex === i ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <div className="px-5 md:px-6 pb-5 text-sm text-gray-600 leading-relaxed">
                  {faq.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}